const UploadDocumentsRenderModes = {
  INPUT: 'Input',
  REVIEW: 'Review',
};
export default UploadDocumentsRenderModes;
